import script from "./FrmSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./FrmSettings.vue?vue&type=script&setup=true&lang=js"

import "./FrmSettings.vue?vue&type=style&index=0&id=01a7b787&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01a7b787"]])

export default __exports__